<template>
    <span v-if="translate && value">{{ $tm(value) }}</span>
    <span v-else>{{ value }}</span>
</template>
<script setup lang="ts">
/**
 * This shows the raw text without any translation or anything
 */
defineProps<{
    /**
     * The text to display
     */
    value: string | null;

    translate?: boolean;
}>();
</script>
